(function () {
    var institutionId = {
        $institutionId: $('.updateInstitutionMessageForm  select#institutionList'),
        $institutionMessage: $('.institutionMessageTextArea'),
        $institutionEnableSelect: $('.enabledTextInput'),

        init: function () {
            institutionId.control();
            institutionId.updateHiddenInput();
        },
        control: function () {
            institutionId.$institutionId.change(function () {
                var $selectedOption = $(this).find(':selected');

                institutionId.updateHiddenInput();
                UX.intitutionId.$institutionMessage.val($selectedOption.data('info'));
                UX.intitutionId.$institutionEnableSelect.val($selectedOption.data('other-info') + '');
            });
        },
        updateHiddenInput: function () {
            $('input[name=institutionId]').attr('value', $('#institutionList').val());
        },
    };

    UX.intitutionId = institutionId;
})();
